/**
 * Режим рабочего пространства (E4.5): рабочий контур или учебный экземпляр. Режим выбирается
 * явно до запуска запросов; рабочий режим никогда не читает учебные данные, учебный --
 * только учебный API и свой manifest.
 */

export type WorkspaceMode = 'live' | { training_instance_id: string };

export const LIVE_MODE: WorkspaceMode = 'live';

/** ID учебного экземпляра режима; null -- рабочий контур */
export function trainingInstanceOf(mode: WorkspaceMode): string | null {
	return mode === 'live' ? null : mode.training_instance_id;
}
